import { ReactElement } from "react"

import CreateEVDCDeviceForm from "../../../../components/devices/lct/evdc/createEVDCDeviceForm"
import NewEVDCDeviceVersionProvider from "../../../../components/devices/lct/evdc/providers/newEVDCDeviceVersionProvider"

const NewEVDCDeviceVersion = (): ReactElement => (
    <NewEVDCDeviceVersionProvider>
        <CreateEVDCDeviceForm />
    </NewEVDCDeviceVersionProvider>
)

export default NewEVDCDeviceVersion
